// Module 0 — Engagement lifecycle constants (frontend mirror of the database rules)
// The database is the source of truth (migrations 002 + 004 + 005). These constants
// only decide what the UI OFFERS — the DB still has the final say on every write.

// The main lifecycle path, in order, as it appears on the status bar.
export const LIFECYCLE_STEPS = [
    'requested',
    'confirmed',
    'scheduled',
    'in_progress',
    'completed',
    'closed'
];

// Side-exits that live off the main path.
export const SIDE_EXITS = ['canceled', 'no_show'];

// Human-friendly labels + pill styling for every status.
export const STATUS_META = {
    requested:   { label: 'Requested',   icon: '📝', pill: 'bg-gray-100 text-gray-700 border-gray-300' },
    confirmed:   { label: 'Confirmed',   icon: '✅', pill: 'bg-blue-100 text-blue-800 border-blue-300' },
    scheduled:   { label: 'Scheduled',   icon: '📅', pill: 'bg-indigo-100 text-indigo-800 border-indigo-300' },
    in_progress: { label: 'In Progress', icon: '🚗', pill: 'bg-amber-100 text-amber-800 border-amber-300' },
    completed:   { label: 'Completed',   icon: '🏁', pill: 'bg-green-100 text-green-800 border-green-300' },
    closed:      { label: 'Closed',      icon: '🔒', pill: 'bg-slate-200 text-slate-800 border-slate-400' },
    canceled:    { label: 'Canceled',    icon: '🚫', pill: 'bg-red-100 text-red-800 border-red-300' },
    no_show:     { label: 'No-Show',     icon: '👻', pill: 'bg-rose-100 text-rose-800 border-rose-300' }
};

// Legal status transitions — an exact mirror of validate_engagement_status_transition()
// in migration 005. Used to decide which action buttons to show; the DB re-checks.
export const ALLOWED_TRANSITIONS = {
    requested:   ['confirmed', 'canceled', 'no_show'],
    confirmed:   ['scheduled', 'canceled'],
    scheduled:   ['in_progress', 'canceled', 'no_show'],
    in_progress: ['completed', 'canceled', 'no_show'],
    completed:   ['closed'],
    closed:      [],
    canceled:    [],
    no_show:     []
};

// Statuses an engagement may be CREATED in (mirror of the INSERT branch in migration 005).
export const CREATABLE_STATUSES = ['requested', 'confirmed', 'canceled', 'no_show'];

export function statusMeta(status) {
    return STATUS_META[status] || { label: status || '—', icon: '•', pill: 'bg-gray-100 text-gray-700 border-gray-300' };
}

export function statusLabel(status) {
    return statusMeta(status).label;
}

export function allowedNextStatuses(status) {
    return ALLOWED_TRANSITIONS[status] || [];
}

export function isSideExit(status) {
    return SIDE_EXITS.includes(status);
}
